var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M9.60005 4.24268C8.66748 4.24268 4.27891 4.9421 4.12805 9.56382C6.48691 9.01525 8.32462 7.13639 8.79091 4.7501C9.51777 6.32725 11.4789 8.5901 14.8663 8.31582C14.2492 5.97068 12.1372 4.24268 9.60005 4.24268Z",
          fill: _vm.color,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M6.17139 11.7857C6.73946 11.7857 7.19997 11.3252 7.19997 10.7571C7.19997 10.189 6.73946 9.72852 6.17139 9.72852C5.60333 9.72852 5.14282 10.189 5.14282 10.7571C5.14282 11.3252 5.60333 11.7857 6.17139 11.7857Z",
          fill: _vm.color,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M13.0286 11.7857C13.5966 11.7857 14.0571 11.3252 14.0571 10.7571C14.0571 10.189 13.5966 9.72852 13.0286 9.72852C12.4605 9.72852 12 10.189 12 10.7571C12 11.3252 12.4605 11.7857 13.0286 11.7857Z",
          fill: _vm.color,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M17.8286 9.72857C17.8286 5.18914 14.1394 1.5 9.6 1.5C5.06057 1.5 1.37143 5.18914 1.37143 9.72857C0.617143 9.72857 0 10.3457 0 11.1V13.8429C0 14.5971 0.617143 15.2143 1.37143 15.2143H2.74286V9.72857C2.74286 5.94343 5.81486 2.87143 9.6 2.87143C13.3851 2.87143 16.4571 5.94343 16.4571 9.72857V16.5857H8.22857V17.9571H16.4571C17.2114 17.9571 17.8286 17.34 17.8286 16.5857V15.2143C18.5829 15.2143 19.2 14.5971 19.2 13.8429V11.1C19.2 10.3457 18.5829 9.72857 17.8286 9.72857Z",
          fill: _vm.color,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }